<template>
  <v-col>
    <points-table
      :customers="records"
      :headers="headers"
      :selection="true"
      @refresh="getRecords"
      @deleteRecord="deleteRecords"
      @suppressRecord="suppressRecords"
    >Manage Points</points-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import pointsTable from "@/components/qantas/points-table";
export default {
  name: "ManageQantasPoints",
  components: {
    pointsTable
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 10,
        descending: false
      },
      headers: [
        {
          text: "CSN",
          value: "csn",
          align: "left",
          sortable: true,
          class: ["strong"]
        },
        {
          text: "Cust #",
          value: "custNo",
          align: "left",
          sortable: true,
          class: ["strong"]
        },
        {
          text: "File Set Number",
          value: "fileSetNumber",
          align: "left",
          sortable: true
        },
        {
          text: "Sequence Number",
          value: "sequenceNumber",
          align: "left",
          sortable: true
        },
        {
          text: "Points Paid",
          value: "pointsPaid",
          align: "left",
          sortable: true
        },
        {
          text: "Bonus Points Paid",
          value: "bonusPointsPaid",
          align: "left",
          sortable: true
        },
        {
          text: "Date Paid",
          value: "datePaid",
          align: "left",
          sortable: true
        },
        {
          text: "Return Result",
          value: "returnResult",
          align: "left",
          sortable: true
        },
        {
          text: "Reason (if rejected)",
          value: "rejectionReason",
          align: "left",
          sortable: true
        }
      ],
      records: []
    };
  },
  mounted() {
    let vm = this;
    vm.getRecords();
  },
  methods: {
    ...mapActions("qantas", [
      "GetManageableRecords",
      "DeleteRecords",
      "SuppressRecords"
    ]),
    getRecords() {
      let vm = this;
      vm.GetManageableRecords().then(data => {
        vm.records = data;
      });
    },
    deleteRecords(records) {
      let vm = this;
      vm.DeleteRecords(records).then(data => {
        vm.records = data;
      });
    },
    suppressRecords(records) {
      let vm = this;
      vm.SuppressRecords(records).then(data => {
        vm.records = data;
      });
    }
  }
};
</script>